<ng-container *ngIf="franchiseExpandableDescription$ | async as expandableDescription">
  <dap-lib-filter-bar
    *ngIf="franchiseOptions$ | async as options"
    [description]="'BASIC_INSURANCE.FRANCHISE.DESCRIPTION' | translate"
    [expandActionText]="'BASIC_INSURANCE.SELECTION.EXPAND' | translate"
    [expandableDescription]="expandableDescription"
    [formControl]="formControlFranchise"
    [options]="options"
    [reduceActionText]="'BASIC_INSURANCE.SELECTION.REDUCE' | translate"
    [title]="'BASIC_INSURANCE.FRANCHISE.TITLE' | translate"
    data-cy="franchise-selection"
  ></dap-lib-filter-bar>
</ng-container>

<dap-lib-filter-bar
  *ngIf="includesAccidentCoverageOptions$ | async as options"
  [description]="'BASIC_INSURANCE.ACCIDENT_COVERAGE.DESCRIPTION' | translate"
  [formControl]="formControlAccidentCoverage"
  [options]="options"
  [title]="'BASIC_INSURANCE.ACCIDENT_COVERAGE.TITLE' | translate"
  data-cy="accident-coverage-selection"
></dap-lib-filter-bar>
